export default "__VITE_ASSET__CwrQ3MrV__"